import { render, staticRenderFns } from "./AnswerDetailServiceDetail.vue?vue&type=template&id=5f3d2146&scoped=true&"
import script from "./AnswerDetailServiceDetail.vue?vue&type=script&lang=js&"
export * from "./AnswerDetailServiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3d2146",
  null
  
)

export default component.exports